<template>
  <!-- Main content area for the website -->
  <main class="website-main">
    <!-- Top gradient wrapping the featured articles component -->
    <div class="gradient-top">
      <!-- Reusable component that lists articles -->
      <v-section-articles />
    </div>

    <!-- Section displayed when user didn't find what they were looking for -->
    <div class="gradient-bottom">
      <section class="default-section changeable">
        <div>
          <!-- Prompt heading -->
          <h2>Nenašli jste, co jste hledali?</h2>
          <!--
        <article>
          <p>
            Lorem ipsum dolor sit amet, cosec tetuer adipiscing elit. Sed vel lectus.
            Lorem ipsum dolor sit amet, cosectetuer adipiscing elit. Lorem ipsum dolor
            sit amet, cosec tetuer adipiscing elit. Sed vel lectus. Lorem ipsum dolor
            sit amet, cosectetuer adipiscing elit. Lorem ipsum dolor sit amet, cosec
            tetuer adipiscing elit. Sed vel lectus. Lorem ipsum dolor sit amet,
            cosectetuer adipiscing elit.
          </p>
        </article> -->
          <!-- Centered call-to-action button linking to free quote page -->
          <div class="d-flex justify-center">
            <v-btn
              href="/kontakt"
              variant="flat"
              size="x-large"
              color="#d90d83"
            >
              Kalkulace zdarma
            </v-btn>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script setup lang="ts">
import { onMounted, defineProps } from 'vue'
import { useMicrositeStore } from '../stores/useMicrositeStore'
import { useArticleStore } from '../stores/useArticleStore'
import VSectionArticles from '../components/v-section/VSectionArticles.vue'

const props = defineProps<{
  microsite: Microsite
  blog: Article[]
}>()

const micrositeStore = useMicrositeStore()
const articleStore = useArticleStore()

// Initialize stores with incoming data when component mounts
onMounted(() => {
  micrositeStore.setMicrosite(props.microsite)
  articleStore.setArticles(props.blog)
})
</script>
